export default __webpack_public_path__ + "assets/mp4/0213a7c80678a5a8b4a6b6806e9d9fd3.mp4";